import { Component, Injector } from '@angular/core';
import { UsersService } from '../users/users.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UseraccesmappingService } from './useraccesmapping.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utilityservice } from '../../utility/utilityservice.service';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Product } from '../myconfiguration/myconfiguration.component';
@Component({
  selector: 'app-useraccessmapping',
  templateUrl: './useraccessmapping.component.html',
  styleUrls: ['./useraccessmapping.component.css']
})
export class UseraccessmappingComponent extends BaseClass{
  productList=[];
  userlist=[];
  uamfrom:FormGroup;
  uamdetails:any;
  CSRFTOKEN=''
  verticallist=[];
    entitylist=[];
    subverticallist=[];
    deplist=[];subdeplist=[];
    countrylist=[];statelist=[];hublist=[];regionlist=[];citylist=[];locationlist=[];
    specialviewrightlist= [
    { labelname: 'Yes', value: 'Y' },
    { labelname: 'No', value: 'N' }
  ];

groupid:any;
companyid:any;
configParams:any;
  ref: DynamicDialogRef | undefined;
verticalid:any;subverticalid:any;departmentid:any;subdepartmentid:any;countryid:any;stateid:any
hubid:any;regionid:any;cityid:any;locationid:any;fld1:any;fld2:any;fld3:any;
  public validation_message = { 
    'user': [{ type: 'required', message: 'User name is required.' }],
    'product': [{ type: 'required', message: 'Product is required.' }],
   };
  constructor(private uamservice:UseraccesmappingService,private fb:FormBuilder,
    private spinner:NgxSpinnerService,public utilityservice:Utilityservice,
     public dialogService: DialogService,
    public PagehelpmodalService: PagehelpmodalService,
    public override injector: Injector  
  ){
    super(injector);
 
  }
  onSelectFromUser(id){
    this.uamfrom.patchValue({product:''});
    
   this.getProductList(id);
  }
  ngOnInit(){
    this.gettoken();
    this.formInitiliaze();
    this.getUserList();
  }
  getProductList(id) {
    this.uamservice.getproductlist(id).subscribe(res => {
      this.productList = res;
    })
  }
  getUserList() {
    this.uamservice.getuser().subscribe(res => {
      this.userlist = res;
    })
  }
  getuserviewright(){
    this.uamservice.getuserspecialviewright(this.uamfrom.get('user').value,this.uamfrom.get('product').value).subscribe(res=>{
      this.uamfrom.patchValue({'specialviewright':res[0].specialviewright})

    })
  }
 
  formInitiliaze() {
      this.uamfrom = this.fb.group({
        user: ['', Validators.compose([Validators.required])],
        product: ['',Validators.compose([Validators.required])],
        entity: [''],
        vertical: [''],
        subvertical: [''],
        department: [''],      
        subdepartment:[''],
        country: [''],
        state: [''],
        hub: [''],
        location: [''],
        region: [''],
        cityid: [''],
        process: [''], 
        specialviewright:[''],
        casetype:[''],
        contractcat:[''],
        category:[''],
        regiscat:[''],
        doccat:[''],
        policytype:[''],
        lawcat:[''],
        fld:[''],
        group:[],
        fld1:[]
  
  
      })
    }
    refresh(){
      this.productList=[];
      this.uamfrom.reset();     
      
    }

    getUAMdetails(userid,productid){     
      
     this.uamservice.getUAM(userid,productid).subscribe(res=>{
      this.uamdetails=res[0].useraccessmapping[0];
      this.groupid=this.uamdetails[0];
      this.companyid=this.uamdetails[1];
      this.verticalid=this.uamdetails[2];
      this.subverticalid=this.uamdetails[3];
      this.departmentid=this.uamdetails[4];
      this.subdepartmentid=this.uamdetails[5];
      this.countryid=this.uamdetails[6];
      this.stateid=this.uamdetails[7];
      this.hubid=this.uamdetails[8];
      this.regionid=this.uamdetails[9];
      this.cityid=this.uamdetails[10];
      this.locationid=this.uamdetails[11];
      this.fld1=this.uamdetails[12];  // for mapping specific mappeddata
      this.fld2=this.uamdetails[13];
      this.fld3=this.uamdetails[14];
         this.utilityservice.fetchAndStoreConfigParams()

    this.getVertical();
    this.getentitylist();
    // this.getsubVerticallist();
    this.getDeplist();
    // this.getsubdeplist();
    this.getcontrylist();
    this.getstatelist();
    this.gethublist();
    this.getRegionlist();
      this.getcitylist();
      this.getlocationlist();
      // specific mapping 
      this.getcontractcategorylist();
       this.getcategorylist();
       this.getregistrationcategory();
       this.getdocumentcategory();
       this.getpolicytype();
       this.getlawcategory();
       this.getprocess();
       this.getusercasetypelist();
       this.getusergroup();
          this.getuserviewright();

      
     })
    }
    
    getVertical(){
      this.verticallist=[]
          this.utilityservice.configParams$.subscribe(res=>{
    this.configParams=res;
    console.log(this.configParams);
    
        if(this.configParams?.requirevertlabel=='Y') {
       this.uamservice.getverrticallist({mappeddata:this.verticalid}).subscribe(res=>{
        this.verticallist=res
        const selectedVerticals = this.verticallist.filter(item => item.selectedverticalid !== null && item.verticalid === item.selectedverticalid);
        // Patch the filtered items to the form control
       this.uamfrom.patchValue({ vertical: selectedVerticals });
      })
    }
       this.getsubVerticallist();

    })

    }
    getusercasetypelist(){
      if(this.uamfrom.get('product').value==9 ){this.casetypelist=[]
      this.uamservice.getusercasetype({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
                  this.casetypelist=res.map(e=>({ labelname: e.casetype, value: e.caseid ,selectedcaseid:e.selectedcaseid}))

            const selectedValue = this.casetypelist.filter(item => item.selectedcaseid !== null && item.value === item.selectedcaseid);
       this.uamfrom.patchValue({ fld1: selectedValue });
       this.getsubVerticallist();
      })}
    }
    getentitylist(){
      this.entitylist=[];
      // const groupid=this.uamfrom.value.group==null ||this.uamfrom.value.group?.length==0 ? '': this.uamfrom.value.group.map(e=>e.groupid).toString()
      const groupid = this.uamfrom.value.group?.length
  ? this.uamfrom.value.group.map(e => e.groupid).toString()
  : '';
      this.uamservice.getentitylist({mappeddata:this.companyid, dynamicquery:'',groupid:groupid}).subscribe(res=>{
        this.entitylist=res;
        const selectedCompanyid = this.entitylist.filter(item => item.selectedcompanyid !== null && item.companyid === item.selectedcompanyid);
        this.uamfrom.patchValue({entity:selectedCompanyid});

      })
    }
        getsubVerticallist(){
          this.subverticallist=[]
          // const vertical=this.uamfrom.value.vertical=='' || this.uamfrom.value.vertical?.length==0 ? '': this.uamfrom.value.vertical.map(e=>e.verticalid).toString();
        if(this.configParams?.requiresubvertlabel=='Y'){
            const vertical=this.uamfrom.value.vertical?.length
  ? this.uamfrom.value.vertical.map(e => e.verticalid).toString()
  : '';
      this.uamservice.getusersubvertical({mappeddata:this.subverticalid, dynamicquery:'',verticalid:vertical}).subscribe(res=>{
        this.subverticallist=res;
            const selecteditem = this.subverticallist.filter(item => item.selectedsubverticalid !== null && item.subverticalid === item.selectedsubverticalid);
        this.uamfrom.patchValue({subvertical:selecteditem});

      })}
    }
        getDeplist(){
          this.deplist=[]
      this.uamservice.getuserdepartment({mappeddata:this.departmentid, dynamicquery:''}).subscribe(res=>{
        this.deplist=res;
          const selecteditem = this.deplist.filter(item => item.selecteddepartmentid !== null && item.departmentid === item.selecteddepartmentid);
        this.uamfrom.patchValue({department:selecteditem});
        this.getsubdeplist();
      })
    }
        getsubdeplist(){
if(this.configParams?.requiresubdeptlabel=='Y'){ 
           this.subdeplist=[];
            const subdepartmentid = this.uamfrom.value.subdepartment?.length
            ? this.uamfrom.value.subdepartment.map(e => e.subdepartmentid).toString()
            : '';
      this.uamservice.getusersubdepartment({mappeddata:this.subdepartmentid, dynamicquery:'',departmentid:subdepartmentid}).subscribe(res=>{
        this.subdeplist=res;
           const selecteditem = this.subdeplist.filter(item => item.selectedsubdepartmentid !== null && item.subdepartmentid === item.selectedsubdepartmentid);
        this.uamfrom.patchValue({subdepartment:selecteditem});
      })}
    }
        getcontrylist(){
        if(this.configParams.iscountry=='Y'){  this.countrylist=[]
      this.uamservice.getusercountry({mappeddata:this.countryid, dynamicquery:''}).subscribe(res=>{
        this.countrylist=res;
            // const selecteditem = this.countrylist.filter(item => item.selectedcountryid !== null && item.countrytid === item.selectedcountryid);
            // console.log(selecteditem,"selecteditem country");
            const selecteditem = this.countrylist.filter(x =>
  Number(x.countryid) === Number(x.selectedcountryid)
);            
        this.uamfrom.patchValue({country:selecteditem});
      })}
    }

       getstatelist(){
        this.statelist=[]
const countryid = this.uamfrom.value.country?.length ? this.uamfrom.value.country.map(e => e.countryid).toString() : '';
      this.uamservice.getuserstate({mappeddata:this.stateid, dynamicquery:'',countryid:countryid}).subscribe(res=>{
        this.statelist=res;
          const selecteditem = this.statelist.filter(item => item.selectedstateid !== null && item.stateid === item.selectedstateid);
        this.uamfrom.patchValue({state:selecteditem});
      })
    }
       gethublist(){
        if(this.configParams.ishub=='Y'){this.hublist=[]
const countryid = this.uamfrom.value.country?.length
  ? this.uamfrom.value.country.map(e => e.countryid).toString()
  : '';
  		const stateid = this.uamfrom.value.state?.length? this.uamfrom.value.state.map(e=>e.stateid).toString():''
      this.uamservice.getuserhub({mappeddata:this.hubid, dynamicquery:'',countryid:countryid,stateid:stateid}).subscribe(res=>{
        this.hublist=res;
         const selecteditem = this.hublist.filter(item => item.selectedhubid !== null && item.hubid === item.selectedhubid);
        this.uamfrom.patchValue({hub:selecteditem});

      })}
    }
       getRegionlist(){
        if(this.configParams.isregion=='Y'){this.regionlist=[]
const countryid = this.uamfrom.value.country?.length
  ? this.uamfrom.value.country.map(e => e.countryid).toString()
  : '';	
  	 const stateid = this.uamfrom.value.state?.length? this.uamfrom.value.state.map(e=>e.stateid).toString():''
		 const hubid =   this.uamfrom.value.hub?.length ? this.uamfrom.value.hub.map(e=>e.hubid).toString():''
       this.uamservice.getuserregion({mappeddata:this.regionid, dynamicquery:'',countryid:countryid,stateid:stateid,hubid:hubid}).subscribe(res=>{
        this.regionlist=res;
        const selecteditem = this.regionlist.filter(item => item.selectedregionid !== null && item.regionid === item.selectedregionid);
        this.uamfrom.patchValue({region:selecteditem});
      })}
    }
       getcitylist(){
        if(this.configParams.iscity=='Y'){this.citylist=[];
const countryid = this.uamfrom.value.country?.length
  ? this.uamfrom.value.country.map(e => e.countryid).toString()
  : '';
  	 const stateid = this.uamfrom.value.state?.length? this.uamfrom.value.state.map(e=>e.stateid).toString():''
		 const hubid =   this.uamfrom.value.hub?.length? this.uamfrom.value.hub.map(e=>e.hubid).toString() :''
		 const regionid =this.uamfrom.value.region?.length? this.uamfrom.value.region.map(e=>e.regionid).toString():''
      this.uamservice.getusercity({mappeddata:this.cityid, dynamicquery:'',countryid:countryid,stateid:stateid,regionid:regionid,hubid:hubid}).subscribe(res=>{
        this.citylist=res;
        const selecteditem = this.citylist.filter(x =>Number(x.cityid) === Number(x.selectedcityid));  
        this.uamfrom.patchValue({cityid:selecteditem});
      })}
    }
      getlocationlist(){
         this.locationlist=[]
const countryid = this.uamfrom.value.country?.length
  ? this.uamfrom.value.country.map(e => e.countryid).toString()
  : '';		 const state = this.uamfrom.value.state?.length? this.uamfrom.value.state.map(e=>e.stateid).toString():''
		 const hub =   this.uamfrom.value.hub?.length?this.uamfrom.value.hub.map(e=>e.hubid).toString():''
    const region =this.uamfrom.value.region?.length? this.uamfrom.value.region.map(e=>e.regionid).toString():''
    const  city = this.uamfrom.value.cityid ==""  || this.uamfrom.value.cityid==null ? '' : this.uamfrom.value.cityid.map(e=>e.cityid).toString()

      this.uamservice.getuserlocation({mappeddata:this.locationid, dynamicquery:'',countryid:countryid,stateid:state,hubid:hub,regionid:region,cityid:city}).subscribe(res=>{
        this.locationlist=res;
            const selecteditem = this.locationlist.filter(item => item.selectedlocationid !== null && item.locationid === item.selectedlocationid);
        this.uamfrom.patchValue({location:selecteditem});
      })
    }
    casetypelist=[]
    getcasetypelist(){
      this.uamservice.getusercasetype({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
      this.casetypelist=res
      })
    }
    processlist=[];
    contcatelist=[];
    regcatelist=[];
    doccatelist=[];
    policytypelist=[];
   
      getcontractcategorylist(){
       this.contcatelist=[];
       if(this.uamfrom.get('product').value==2)
   {   this.uamservice.getusercontractcategory({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
                this.contcatelist=res.map(e=>({ labelname: e.categoryname, value: e.contcategoryid ,selectedcontcategoryid:e.selectedcontcategoryid}))

         const selecteditem = this.contcatelist.filter(item => item.selectedcontcategoryid !== null && item.value === item.selectedcontcategoryid);
        this.uamfrom.patchValue({fld1:selecteditem});
      })}
    }
    assementcategorylist=[];
    assignemntcategroy=[]

    getcategorylist(){
   
      this.assementcategorylist=[];
      this.assignemntcategroy=[]
      if(this.uamfrom.get('product').value==16){
       this.uamservice.getuserassignmentcategory({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
            // this.assignemntcategroy=res;
                 this.assignemntcategroy=res.map(e=>({ labelname: e.categoryname, value: e.categoryid ,selectedcategoryid:e.selectedcategoryid}))

         const selecteditem = this.assignemntcategroy.filter(item => item.selectedcategoryid !== null && item.value === item.selectedcategoryid);
        this.uamfrom.patchValue({fld1:selecteditem});
      })
    }
    else if(this.uamfrom.get('product').value==3){
       this.uamservice.getuserassessmentcategory({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
      // this.assementcategorylist=res;
                this.assementcategorylist=res.map(e=>({ labelname: e.tax, value: e.taxid ,selectedtaxid:e.selectedtaxid}))

           const selecteditem = this.assementcategorylist.filter(item => item.selectedtaxid !== null && item.value === item.selectedtaxid);
        this.uamfrom.patchValue({fld1:selecteditem});
      })
    }
    }
    getregistrationcategory(){
      this.regcatelist=[]
       if(this.uamfrom.get('product').value==4){this.uamservice.getuserregistrationcategory({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
                this.regcatelist=res.map(e=>({ labelname: e.categoryname, value: e.regcategoryid ,selectedregcategoryid:e.selectedregcategoryid}))

        const selecteditem = this.regcatelist.filter(item => item.selectedregcategoryid !== null && item.value === item.selectedregcategoryid);
        this.uamfrom.patchValue({fld1:selecteditem});
      })}
    }
     getdocumentcategory(){
      this.doccatelist=[]
      if(this.uamfrom.get('product').value==5){ this.uamservice.getuserdocumentcategory({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
                this.doccatelist=res.map(e=>({ labelname: e.name, value: e.id ,selectedid:e.selectedid}))

          const selecteditem = this.doccatelist.filter(item => item.selectedid !== null && item.value === item.selectedid);
        this.uamfrom.patchValue({fld1:selecteditem});
      })}
    }
      getpolicytype(){
      this.policytypelist=[]
      if(this.uamfrom.get('product').value==11){
       this.uamservice.getuserinspolicytype({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
                this.policytypelist=res.map(e=>({ labelname: e.policytypename, value: e.policytypeid ,selectedpolicytypeid:e.selectedpolicytypeid}))

         const selecteditem = this.policytypelist.filter(item => item.selectedpolicytypeid !== null && item.value === item.selectedpolicytypeid);
        this.uamfrom.patchValue({fld1:selecteditem});
      })}
    }
    lawcatlist=[]
    getlawcategory(){
      this.lawcatlist=[]
      if(this.uamfrom.get('product').value==1){this.uamservice.getuserlawcategory({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
                this.lawcatlist=res.map(e=>({ labelname: e.name, value: e.id ,selectedid:e.selectedid}))

          const selecteditem = this.lawcatlist.filter(item => item.selectedid !== null && item.value === item.selectedid);
        this.uamfrom.patchValue({fld1:selecteditem});
      
      })}
    }
    grouplist=[]
    getusergroup(){
    
     if(this.utilityservice.getLoggeduser().orgtype=='P' && this.configParams.orgtype=='P')
     { this.uamservice.getusergroup({mappeddata:this.groupid,dynamicquery:''}).subscribe(res=>{
        this.grouplist=res;
              const selecteditem = this.grouplist.filter(item => item.selectedgroupid !== null && item.groupid === item.selectedgroupid);
        this.uamfrom.patchValue({group:selecteditem});
      })}
    }

     getifcprocesslist(){
      if(this.uamfrom.get('product').value==8 || this.uamfrom.get('product').value==13){ this.processlist=[]
      this.uamservice.getuserifcprocess({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
                this.processlist=res.map(e=>({ labelname: e.processname, value: e.processid ,selectedprocessid:e.selectedprocessid}))

             const selecteditem = this.processlist.filter(item => item.selectedprocessid !== null && item.value === item.selectedprocessid);
        this.uamfrom.patchValue({fld1:selecteditem});
      })}
    }
      getiaprocesslist(){
      this.uamservice.getuseriaprocess({mappeddata:this.fld1,dynamicquery:''}).subscribe(res=>{
          this.processlist=res.map(e=>({ labelname: e.processname, value: e.processid ,selectedprocessid:e.selectedprocessid}))

       const selecteditem = this.processlist.filter(item => item.selectedprocessid !== null && item.value === item.selectedprocessid);
        this.uamfrom.patchValue({fld1:selecteditem});
      
      })
    }
    getprocess(){
              if( this.uamfrom.get('product').value==13){
              this.getifcprocesslist()

              }
              if(this.uamfrom.get('product').value==8){
        this.getiaprocesslist();}

      // if(this.uamfrom.get('product').value==13){
      //   this.getifcprocesslist()
      // }else if(this.uamfrom.get('product').value==8){
      //   this.getiaprocesslist();
      // }
    }
fldPayloadValue=''
getfld1(value,label){
  this.fldPayloadValue=''
  if(label=='Process'){
     this.fldPayloadValue=value.map(e=>e.processid).toString()
  }
  else if(label=='Case Type'){
     this.fldPayloadValue=value.map(e=>e.caseid).toString()

  }
    else if(label=='Contract Category'){
          this.fldPayloadValue=value.map(e=>e.contcategoryid).toString()

  }
      else if(label=='Categoryon16'){
          this.fldPayloadValue=value.map(e=>e.taxid).toString()

  }
      else if(label=='Categoryon3'){
          this.fldPayloadValue=value.map(e=>e.categoryid).toString()

  }
      else if(label=='Registration Category'){
          this.fldPayloadValue=value.map(e=>e.regcategoryid).toString()

  }
      else if(label=='Document Category'){
          this.fldPayloadValue=value.map(e=>e.id).toString()

  }
      else if(label=='Policy Type'){
          this.fldPayloadValue=value.map(e=>e.policytypeid).toString()

  }
      else if(label=='Law Category'){
          this.fldPayloadValue=value.map(e=>e.id).toString()

  }
  return this.fldPayloadValue
    
      
}
    saveuam(){
      
      console.log(this.uamfrom.value);
      
  if (this.uamfrom.invalid) {
        this.validateAllFormFields(this.uamfrom);
      }else{        
      const payload={
     groupid : (this.uamfrom.value.group ?? [])
  .map(e => e.groupid)
  .join(','),//this.uamfrom.value.group==null ||this.uamfrom.value.group?.length? this.uamfrom.value.group.map(e=>e.groupid).toString():'',
		 companyid : this.uamfrom.value.entity=='' || this.uamfrom.value.entity?.length? this.uamfrom.value.entity.map(e=>e.companyid).toString():'',
		// verticalid : this.uamfrom.value.vertical=='' || this.uamfrom.value.vertical?.length? this.uamfrom.value.vertical.map(e=>e.verticalid).toString():'',
     verticalid: Array.isArray(this.uamfrom.value.vertical) && this.uamfrom.value.vertical.length? this.uamfrom.value.vertical.map(e => e.verticalid).toString(): '',
     subverticalid : this.uamfrom.value.subvertical?.length? this.uamfrom.value.subvertical.map(e=>e.subverticalid).toString():'',
		 departmentid : this.uamfrom.value.department?.length?this.uamfrom.value.department.map(e=>e.departmentid).toString():'',
     subdepartmentid : this.uamfrom.value.subdepartment?.length
  ? this.uamfrom.value.subdepartment.map(e => e.subdepartmentid).toString()
  : '',
		 countryid :this.uamfrom.value.country?.length
  ? this.uamfrom.value.country.map(e => e.countryid).toString()
  : '',
		 stateid : this.uamfrom.value.state?.length?this.uamfrom.value.state.map(e=>e.stateid).toString():'',
		 hubid :    this.uamfrom.value.hub?.length? this.uamfrom.value.hub.map(e=>e.hubid).toString():'',
		 regionid :this.uamfrom.value.region?.length?this.uamfrom.value.region.map(e=>e.regionid).toString():'',
		 cityid : this.uamfrom.value.cityid ==""  || this.uamfrom.value.cityid==null ? '' : this.uamfrom.value.cityid.map(e=>e.cityid).toString(),
    locationid :this.uamfrom.value.location?.length?this.uamfrom.value.location.map(e=>e.locationid).toString():'',
		 fld1 :this.uamfrom.value.fld1?.length?this.uamfrom.value.fld1.map(e=>e.value).toString():'',//this.fldPayloadValue,
		 productid : this.uamfrom.value.product.toString(), 
     userid : this.uamfrom.value.user.toString(), 
     specialviewright :this.uamfrom.value.specialviewright==null ? 'N':  this.uamfrom.value.specialviewright,//specialviewright
    //  specialviewright:this.uamfrom.value.specialviewright,
     csrftoken:this.CSRFTOKEN
      }
        Swal.fire({
             title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
            }).then((result)=>{
               if (result.isConfirmed) {
                   this.spinner.show();
      this.uamservice.savedata(payload).subscribe(res=>{
      this.spinner.hide();
      // this.refrsh()
       Swal.fire("User is mapped successfully!", "", "success").then(()=>{
              this.refresh();
              // this.gettoken()

       })

      },error=>{
       this.spinner.hide();
        Swal.fire(error.error.message,'','error');
    })
  }
      else if(result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
            })
          }
    }
      gettoken(){
            this.CSRFTOKEN='';
             this.utilityservice.getCSRFtoken().subscribe(res=>{
             this.CSRFTOKEN=res.csrf;
            },error=>{
              Swal.fire(error.error.message,'','error');
            });
          }

   deletemapping(){    
        Swal.fire({
              title: "Are you sure you want to delete this user mapping?",
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: "Yes , I am Sure",
              denyButtonText: `Don't Save`,
              icon: "warning"
            }).then((result) => {
            if (result.isConfirmed) {
              this.spinner.show();
                const payload={
                     productid:this.uamfrom.get('product').value,
                     userid:this.uamfrom.get('user').value,
                     csrftoken:this.CSRFTOKEN
                 }
              this.uamservice.deleteUAM(payload).subscribe((res:any) => {
                this.spinner.hide();
                if (res.response == 'success') {
                  this.refresh()
                  Swal.fire("User`s mapping is deleted successfully!", "", "success");

                } else {
                  Swal.fire({ icon: "error", title: "Oops...", text: "Response is null" });
                }
              }, error => {
                this.spinner.hide()
                Swal.fire({ icon: "error", title: "Oops...", text: error.error.message, footer: "error status is :" + ' ' + error.status });
              })
      
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
         
          }
}
